<template>
  <div class="tw-flex tw-flex-col" :class="gapClass">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(defineProps<{ gap?: 'sm' | 'md' | 'lg' }>(), { gap: 'md' })

const gapClass = computed(
  () => ({ sm: 'tw-gap-2', md: 'tw-gap-3', lg: 'tw-gap-6' })[props.gap] ?? 'tw-gap-3',
)
</script>
